import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { OauthType } from '@flashvpn-io/web-core';

@Component({
  selector: 'app-user-tabs',
  template: `
    <div class="container">
      <button
        *ngFor="let tab of tabs; let i = index"
        type="button"
        (click)="linkTo(tab.value)"
        [class.right]="i === 0"
        [class.active]="tab.value === activatedType"
        class="tab">
        {{ tab.title | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        .container {
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #ffffff1a;
        }

        .right {
          margin-right: 20px;
        }

        .tab {
          font-family: 'Noto Sans SC';
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0.01em;
          text-align: left;
          color: var(--white);
          padding-bottom: 8px;
          background: none;
          border: none;
          outline: none;
          appearance: none;
          cursor: pointer;

          &.active {
            border-bottom: 3px solid var(--red);
          }
        }
      }
    `,
  ],
})
export class UserTabsComponent {
  @Input() public activatedType: OauthType = OauthType.SIGNIN;

  tabs: Tab[] = [
    {
      title: 'Menu.login',
      value: OauthType.SIGNIN,
    },
    {
      title: 'Menu.register',
      value: OauthType.SIGNUP,
    },
  ];
  constructor(private router: Router) {}

  linkTo(oauthType: OauthType) {
    if (oauthType !== this.activatedType) {
      this.router.navigate(['users', oauthType]);
    }
  }

  protected readonly OauthType = OauthType;
}
interface Tab {
  title: string;
  value: OauthType;
}
